import { useState } from 'react';
import { useBreakpointFits } from 'use-react-breakpoint';

type Override = boolean | undefined;

const topic = 'set-is-mobile-override';
const getValue = () => {
  const stored = sessionStorage.getItem(topic);
  return stored ? stored === 'true' : undefined;
};
let updateMobileOverride: (isMobile: Override) => void = () => {};

export const useMobileConfigured = () => {
  const isMobile = !useBreakpointFits('sm');
  const [mobileOverride, setMobileOverride] = useState<Override>(getValue);
  updateMobileOverride = setMobileOverride;

  return mobileOverride ?? isMobile;
};

window.addEventListener('message', event => {
  const data: unknown = event.data;

  if (!data || typeof data !== 'object') return;
  if (!('type' in data) || data.type !== topic) return;
  if (!('isMobile' in data)) return;

  const { isMobile } = data;
  const value = typeof isMobile === 'boolean' ? isMobile : undefined;
  value === undefined
    ? sessionStorage.removeItem(topic)
    : sessionStorage.setItem(topic, String(value));

  return updateMobileOverride(value);
});
